.periodCell {
  width: 20%;
}
.practiceactivityCell {
  width: 40%;
}
.classCell {
  width: 10%;
}
.studentCell {
  width: 5%;
}
.statusCell {
  width: 15%;
}
.buttonCell {
  width: 10%;
}
